<script>
/* eslint-disable no-underscore-dangle */
/**
 * Gráfico misto (área + barras) para evolução da performance.
 * Importa o BarChart do projeto para aplicar cantos arredondados nas barras.
 */
import { Bar } from 'vue-chartjs'
import '@/views/dashboard/notification/charts-components/ChartjsComponentBarChart.vue'

export default {
  name: 'McRecommendationMixedChart',
  extends: Bar,
  props: {
    mixedData: {
      type: Object,
      default: null,
    },
    mixedOptions: {
      type: Object,
      default: null,
    },
  },
  watch: {
    mixedData: {
      deep: true,
      handler() {
        this.updateChart()
      },
    },
    mixedOptions: {
      deep: true,
      handler() {
        this.updateChart()
      },
    },
  },
  mounted() {
    this.renderIfOk()
  },
  methods: {
    renderIfOk() {
      if (!this.mixedData || !this.mixedData.labels || !this.mixedData.labels.length) return
      this.renderChart(this.mixedData, this.mixedOptions)
    },
    updateChart() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderIfOk()
    },
  },
}
</script>
